import { AddressValidationErrors } from '@core/enums/address-validation-errors.enum';

export const AddressValidationErrorMessages = {
  // eslint-disable-next-line max-len
  [AddressValidationErrors.ForbiddenState]: $localize`The state you have chosen is not yet available!`,
};
